<template>
<w-sliding-popup type="full" title="Flow Map 분석" ref="slidingPopup" @close="close" :default-content="false">
  <!-- class="body-no-footer" 삭제 190805-->
  <el-row slot="content" type="flex">
    <!-- Flow Map 조건 설정 -->
    <el-col class="body-content-side body-content" :span="12">
      <el-form :model="filter" class="mr-b10" ref="filterForm">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item prop="deviceIp" label="장비 선택">
              <el-select class="custom-input" style="width:100%;" v-model="filter.deviceIp" @change="onDeviceSelectChange">
                <el-option v-for="nd in flowMapDeviceList" :key="nd.deviceIpaddress" :label="nd.objName" :value="nd.deviceIpaddress"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="input" label="인터페이스 선택">
              <el-select class="custom-input" style="width:100%;" v-model="filter.input" :disabled="!ndSelected">
                <el-option v-for="ni in selectedNetdevice.netinterfaceList" :key="ni.netinterfaceIfindex" :label="ni.netinterfaceName" :value="ni.netinterfaceIfindex"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item prop="meter" label="표현 개수">
              <el-select class="custom-input" style="width:100%;" v-model="filter.meter">
                <el-option v-for="meter in [{ label: '상위(Bytes)', key: 'octets' },{ label: '상위(Packets)', key: 'packets' }]" :key="meter.key" :label="meter.label" :value="meter.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="count">
              <span slot="label">&nbsp;</span>
              <el-select class="custom-input" style="width:100%;" v-model="filter.count">
                <el-option v-for="size in [25, 50, 100]" :key="size" :label="size" :value="size"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="end">
          <el-button style="width:100px;" type="solid" :disabled="!niSelected" @click="loadFlowMapData">조회</el-button>
        </el-row>
      </el-form>
      <hr class="mr-b10"/>
      <!-- Flow Map -->
      <w-flow-map-component ref="flowMap" @node-click="onFlowMapNodeClick"></w-flow-map-component>
    </el-col>
    <!-- Flow 상세 정보 -->
    <el-col class="body-content" :span="12" v-loading="loading">
      <div class="title-bar title-h3">선택 Flow 상세정보</div>
      <div class="list form-list mr-b25">
        <el-form :model="flowMapSelectedIp" label-width="80px" label-position="left" ref="detailForm">
          <el-form-item label="기간"><span>{{ flowMapSelectedIp.dateLabel }}</span></el-form-item>
          <el-form-item prop="name" label="선택한 IP"><span>{{ flowMapSelectedIp.name }}</span></el-form-item>
          <el-form-item prop="hostName" label="호스트명"><span>{{ flowMapSelectedIp.hostName }}</span></el-form-item>
        </el-form>
      </div>
      <div class="title-bar title-h3">Conversation 목록</div>
      <el-table-wrapper height="580" :columns="tableColumns" :column-default="columnDefault" :data="flowMapList" :pagination="false"></el-table-wrapper>
    </el-col>
  </el-row>
</w-sliding-popup>
</template>

<script>
import uniq from 'lodash/uniq';
import { isEmpty } from '@/utils/basic';
import { convertValuByUnit } from '@/utils/number';
import { getDateToString } from '@/utils/date';
import MsgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import flowAPI from '@/api/performance/flow-analysis/flow-analysis';
import WFlowMapComponent from './FlowMapComponent';

export default {
  name: 'WFlowMapAnalysisPopup',
  components: {
    WFlowMapComponent,
  },
  props: {
    analysisType: String,
    flowMapParams: Object,
  },
  data() {
    return {
      popupVisible: false,
      trafficData: [],
      flowMapDeviceList: [],
      ndSelected: false,
      niSelected: false,
      selectedNetdevice: {
        netinterfaceList: [],
      },
      filter: {
        deviceIp: '',
        input: '',
        meter: 'octets',
        count: 25,
      },
      columnDefault,
      tableColumns: [
        {
          prop: 'srcIp',
          label: 'Src IP',
        },
        {
          prop: 'dstIp',
          label: 'Dst IP',
        },
        {
          prop: 'octetsSum',
          label: 'Bytes',
          width: 150,
          formatter: this.convertValue,
        },
        {
          prop: 'packetsSum',
          label: 'Packet',
          width: 150,
          formatter: this.convertValue,
        },
      ],
      flowMapSelectedIp: {
        dateLabel: '-',
        name: '-',
        hostName: '-',
      },
      flowMapList: [],
      loading: false,
    };
  },
  computed: {
    params() {
      return {
        flowMapFilter: {
          deviceIp: this.filter.deviceIp,
          input: this.filter.input,
        },
        startDateTime: this.flowMapParams.startDateTime,
        endDateTime: this.flowMapParams.endDateTime,
        meter: this.filter.meter,
        count: this.filter.count,
        order: 'desc',
      };
    },
  },
  watch: {
    'filter.deviceIp': {
      handler(val) {
        if (val.length > 0) this.ndSelected = true;
        else this.ndSelected = false;
      },
    },
    'filter.input': {
      handler(val) {
        if (val.toString().length > 0) this.niSelected = true;
        else this.niSelected = false;
      },
    },
  },
  methods: {
    /**
     * 플로우맵 팝업 open
     * @author jeee12
     */
    open() {
      this.popupVisible = true;
      this.$refs.slidingPopup.visible = true;
      this.loadFlowMapDevices();
    },
    /**
     * 플로우맵 팝업 close
     * @author jeee12
     */
    close() {
      this.popupVisible = false;
      this.$refs.slidingPopup.visible = false;
      this.$refs.flowMap.initFlowMap(); // flow map 초기화
      // 데이터 초기화
      this.$refs.filterForm.resetFields();
      this.$refs.detailForm.resetFields();
      this.flowMapList = [];
    },
    /**
     * 플로우맵 장비 목록 load
     * @author jeee12
     */
    loadFlowMapDevices() {
      flowAPI.getFlowMapDeviceList().then((response) => {
        if (response.data.success) {
          this.flowMapDeviceList = response.data.data;

          if (this.analysisType === 'netdevice') {
            // netinterface Top1 조회하여 선택 (netinerfaceIfindex)
            this.getTopNetinerfaceIndex();
          } else if (this.analysisType === 'netinterface') {
            this.setFilters(this.flowMapParams.deviceIp, this.flowMapParams.input);
          }
        }
      });
    },
    /**
     * 특정 장비를 필터링 조건으로 설정
     * @author jeee12
     * @param  {[type]} deviceIpaddress [description]
     * @param  {[type]} input           [description]
     */
    setFilters(deviceIpaddress, input) {
      const device = this.flowMapDeviceList.find((e) => e.deviceIpaddress === deviceIpaddress);
      if (isEmpty(device)) {
        return;
      }
      this.selectedNetdevice = device;
      this.filter.deviceIp = device.deviceIpaddress;
      this.filter.input = Number(input) || device.netinterfaceList[0].netinterfaceIfindex;
    },
    /**
     * 특정 장비의 트래픽 Top1 인터페이스 번호 조회
     * @author jeee12
     * @param  {[type]} selected [description]
     */
    getTopNetinerfaceIndex(selected) {
      const deviceIp = selected || this.flowMapParams.deviceIp;
      const params = {
        flowMapFilter: {
          deviceIp,
        },
        startDateTime: this.params.startDateTime,
        endDateTime: this.params.endDateTime,
      };
      let input;
      flowAPI
        .getFlowMapInterfaceList({
          requestParamVO: params,
        })
        .then((response) => {
          if (response.data.success && response.data.data) {
            input = response.data.data[0].info[0].value; // netinterfaceIfindex
          }
          this.setFilters(deviceIp, input);
        });
    },
    /**
     * 장비 선택 change (Top1 인터페이스 조회 위한 서버 호출)
     * @author jeee12
     * @param  {[type]} selected [description]
     */
    onDeviceSelectChange(selected) {
      this.getTopNetinerfaceIndex(selected);
    },
    /**
     * 플로우 맵 데이터 조회 및 가공
     * @author jeee12
     */
    loadFlowMapData() {
      flowAPI
        .getFlowMapData({
          requestParamVO: this.params,
        })
        .then((response) => {
          if (response.data.success) {
            if (response.data.data && response.data.data.length > 0) {
              const trafficData = response.data.data;
              const trafficResultList = [];
              const ipList = [];
              const dstInfoList = {};

              trafficData.forEach((data) => {
                const info = data.info;
                ipList.push(info[0].value); // srcIp
                ipList.push(info[1].value); // dstIp
                if (!dstInfoList[info[0].value]) dstInfoList[info[0].value] = [];
                if (!dstInfoList[info[1].value]) dstInfoList[info[1].value] = [];
                dstInfoList[info[0].value].push({
                  name: info[1].value,
                  value: data[`${this.filter.meter}Sum`], // octetsSum or packetsSum
                });
              });

              uniq(ipList).forEach((ip) => {
                // 조회된 ip목록 중복 제거
                trafficResultList.push({
                  // flow map에 생성될 노드 리스트 가공
                  name: ip,
                  conversationList: dstInfoList[ip],
                });
              });

              this.$refs.flowMap.d3DrawMap(trafficResultList);
            } else {
              this.$message(MsgUtil.getCustomResultMsgData('조회 결과가 없습니다.', false));
            }
          }
        });
    },
    /**
     * 플로우 맵 특정 노드의 conversation 목록 조회
     * @author jeee12
     * @param  {[type]} data 선택한 노드 data
     * @return {[type]}      [description]
     */
    onFlowMapNodeClick(data) {
      this.loading = true;
      this.flowMapSelectedIp = data;

      const params = Object.assign(this.params, {
        flowMapSelectedIp: data.key,
      });

      flowAPI
        .getFlowMapDetailInfo({
          requestParamVO: params,
        })
        .then((response) => {
          if (response.data.success) {
            const flowInfo = response.data.data.flowDetail;
            const flowMapList = response.data.data.conversationList.map((element) => ({
              srcIp: element.info[0].value, // srcIp
              dstIp: element.info[1].value, // dstIp
              octetsSum: element.octetsSum,
              packetsSum: element.packetsSum,
            }));

            this.flowMapSelectedIp.dateLabel = `${this.getDateFormatter(this.flowMapParams.startDateTime)} ~ ${this.getDateFormatter(this.flowMapParams.endDateTime)}`;
            if (!flowInfo) {
              this.flowMapSelectedIp.hostName = '-';
            } else {
              this.flowMapSelectedIp.hostName = flowInfo.aliasName || flowInfo.domainName;
            }
            this.flowMapList = flowMapList;
            this.loading = false;
          }
        });
    },
    /**
     * 테이블 값 (Bytes, Packet) 단위 변환
     * @author jeee12
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertValue(row, column, value) {
      if (column.property === 'octetsSum') return convertValuByUnit(value, 'Byte', true, true, true);
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/, ','); // packets 천단위 분리
    },
    /**
     * 기간 날짜 형 변환
     * @author jeee12
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getDateFormatter(value) {
      return getDateToString(value, 'YYYY-MM-DD HH:mm');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/FlowAnalysis/components/popup/FlowMapAnalysisPopup.vue